/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import './steps.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMedia } from 'domains/commons/hooks/use-media';
import ROUTES from 'libs/constants/routes';
import ImageLeftSidebar from '../../../assets/images/svg/img-left-sidebar.svg';
import { getURLRedirectChannelPage } from 'libs/utils/redirectChannel';

export const Steps = () => {
  const { isMobile } = useMedia();
  const navigateTo = useNavigate();

  const [steps, setSteps] = useState([
    {
      active: false,
      done: false,
      name: 'Elige un plan',
    },
    {
      active: false,
      done: false,
      name: 'Confirmación',
    },
  ]);
  const location = useLocation();
  const { channel = null } = useParams();
  useEffect(() => {
    switch (location.pathname) {
      case getURLRedirectChannelPage('cotizacion', channel!):
      case ROUTES.STEP2_MIRROW:
        setSteps([
          {
            active: true,
            done: false,
            name: 'Elige un plan',
          },
          {
            active: false,
            done: false,
            name: 'Confirmación',
          },
        ]);
        break;
      case getURLRedirectChannelPage('resumen', channel!):
      case ROUTES.STEP3_MIRROW:
        setSteps([
          {
            active: false,
            done: true,
            name: 'Elige un plan',
          },
          {
            active: true,
            done: false,
            name: 'Confirmación',
          },
        ]);
        break;

      default:
        break;
    }
  }, [location]);

  return (
    <div className="steps">
      <div className="progress">
        <div
          className="progress-complete"
          style={{
            width: `${location.pathname === ROUTES.STEP2 ? '50%' : '100%'}`,
          }}
        />
      </div>
      <div className="steps-content">
        <span className="arrow-left" onClick={() => navigateTo(-1)} />
        <ul className="step-progress">
          {steps.map((item, index) => {
            return (
              <li
                className={`step-progress_item ${item.active ? 'is-active' : item.done ? 'is-done' : ''
                  }`}
                key={index}
              >
                <div className="step">
                  <p className="step_item">
                    {isMobile
                      ? `PASO ${index + 1} de ${steps.length}`
                      : `PASO ${index + 1}`}
                    <span className="step_title">{item.name}</span>
                  </p>
                </div>
                <span
                  className={`step-circle${item.active ? '-active' : item.done ? '-done' : ''
                    }`}
                >
                  {item.done ? '✔' : index + 1}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="steps__image">
        <img src={ImageLeftSidebar} alt="sidebar" />
      </div>
    </div>
  );
};
